@if ((notificacoesService.items$ | async).length > 0) {
  <ul class="list-unstyled mb-0">
    @for (item of notificacoesService.items$ | async; track item) {
      <li class="text-nowrap dropdown-item"
        >
        <a class="d-inline"
          [routerLink]="item.url"
          [target]="item.target || null"
          [title]="'Visualizar ' + (item.title || 'notificação')">
          <span>{{ item.title }}</span> <br>
          @if (item?.description) {
            <span class="small">
              {{ item.description }}
            </span>
          }
        </a>
        @if (item.showDismiss) {
          <button
            class="btn btn-sm btn-outline-danger rounded-circle py-0 ms-2 pe-1"
            title="Dispensar notificação"
            (click)="dismissNotification(item)">
            <i class="fa fa-close"></i>
          </button>
        }
      </li>
    }
    <li class="text-nowrap text-center">
      <button
        class="btn botao"
        (click)="clearNotifications()">
        Limpar notificações
      </button>
    </li>
  </ul>
} @else {
  <ul class="list-unstyled mb-0">
    <li class="dropdown-sem-notificacao hand">
      Sem notificações no momento
    </li>
  </ul>
}



